module.exports = __webpack_public_path__ + "img/03-2-3架构设计.85e9ecab.svg";